import { useEffect, useRef, useState } from "react";

export const toDe = (iso) => (/^\d{4}-\d{2}-\d{2}$/.test(iso || "") ? iso.split("-").reverse().join(".") : "");
export const toIso = (t) => {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(t || "");
  if (!m) return null;
  const d = new Date(`${m[3]}-${m[2]}-${m[1]}T12:00:00`);
  return d.getDate() === Number(m[1]) && d.getMonth() + 1 === Number(m[2]) ? `${m[3]}-${m[2]}-${m[1]}` : null;
};
export const maskDate = (raw) => { const d = raw.replace(/\D/g, "").slice(0, 8); return [d.slice(0, 2), d.slice(2, 4), d.slice(4)].filter(Boolean).join("."); };

export const BirthdayInput = ({ value, onChange, min = "1900-01-01", max = new Date().toISOString().slice(0, 10), ...rest }) => {
  const [text, setText] = useState(toDe(value));
  const ref = useRef(null);
  useEffect(() => { if (value && toIso(text) !== value) setText(toDe(value)); else if (!value && toIso(text) && toIso(text) >= min && toIso(text) <= max) setText(""); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const iso = toIso(text);
    const msg = !text ? "" : !iso ? "Bitte gib dein Geburtsdatum als TT.MM.JJJJ ein, z. B. 14.03.1988." : (iso < min || (max && iso > max)) ? "Bitte prüfe das Jahr deines Geburtsdatums." : "";
    ref.current?.setCustomValidity(msg);
  }, [text, min, max]);
  const change = (e) => { const raw = e.target.value; const t = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? toDe(raw) : maskDate(raw); setText(t); const iso = toIso(t); onChange({ target: { value: iso && iso >= min && (!max || iso <= max) ? iso : "" } }); };
  return <input {...rest} ref={ref} type="text" inputMode="numeric" autoComplete="bday" placeholder="TT.MM.JJJJ" maxLength={10} value={text} onChange={change} />;
};
